import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router'

import { REQUEST_PROFILE_TAB_EMAILS_THREAD_QUERY_PARAM_KEY } from '../../../RequestProfileTabEmails.constants'
import { RequestProfileTabEmailsThreadModal } from '../../../RequestProfileTabEmailsThreadModal'

export function useRequestProfileTabEmailsInitialThreadModal({
  filterValues,
  isPreview = false,
  items,
  ordering,
  requestId,
  setModal,
  onCloseModal,
  onReload,
  onSuccessRead,
}) {
  const [searchParams] = useSearchParams()

  const hasOpenedInitialThreadModalRef = useRef(false)

  function openInitialThreadModal() {
    const threadUuid = searchParams.get(
      REQUEST_PROFILE_TAB_EMAILS_THREAD_QUERY_PARAM_KEY
    )

    // Waits for the table to load, not for rows: the thread comes from its
    // detail endpoint, so a page emptied by a filter must not swallow the link
    if (
      !isPreview &&
      threadUuid &&
      Array.isArray(items?.items) &&
      !hasOpenedInitialThreadModalRef.current
    ) {
      hasOpenedInitialThreadModalRef.current = true

      setModal(
        <RequestProfileTabEmailsThreadModal
          mailUuid={threadUuid}
          navigationContext={{ filterValues, ordering, requestId }}
          requestId={requestId}
          onClose={onCloseModal}
          onReload={onReload}
          onSuccessRead={onSuccessRead}
        />
      )
    }
  }

  useEffect(() => {
    openInitialThreadModal()
  }, [items])
}
